<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="40" height="47" viewBox="0 0 40 47">
    <path id="Многоугольник_10" data-name="Многоугольник 10"
      d="M20.913,4.4a3,3,0,0,1,5.173,0L44.345,35.48A3,3,0,0,1,41.758,40H5.242a3,3,0,0,1-2.587-4.52Z"
      transform="translate(40) rotate(90)" fill="#f2f3f5" />
  </svg>
</template>
